module.exports = __webpack_public_path__ + "images/landing/video-previews/Brooklyn_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Brooklyn_2x.jpg
// module id = wvc0
// module chunks = 1